import { useContext, FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'contexts';
import { Role } from 'types';
import { DirectionProvider } from '@radix-ui/react-direction';
import { useRTL } from 'hooks/useRTL';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
  children: JSX.Element;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ children, requireAdmin }) => {
  const { isRTL } = useRTL();
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const { role } = useContext(AuthContext);

  useEffect(() => {
    if (!authContext?.isAuthenticated) {
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    if (requireAdmin && role !== Role.ADMIN) {
      navigate('/login');
    }
  }, [role, requireAdmin]);

  return <DirectionProvider dir={isRTL ? 'rtl' : 'ltr'}>{children}</DirectionProvider>;
};
